const footerStyles = {
    footer_wrpr: `container mt-12
                  sm:mt-24
    `,
    footer_container: `grid grid-cols-1 gap-5
                      screen-970:grid-cols-4 screen-970:gap-10 screen-970:px-10
                      sm:grid-cols-2 sm:gap-6 sm:px-5
    `,
    footer_logo: `flex-1 mb-4`,
    footer_image: `h-auto w-[94px] max-w-full`,
    footer_sub_section: `flex-1 mb-4 mt-0
                          screen-970:mt-11
                          md:mb-0
    `,
    contact_us: `font-[500] text-[18px] leading-[normal] mb-4`,
    list_container: `space-y-2 md:space-y-5`,
    list: `flex items-center text-[16px] font-[300] leading-[normal]`,
    contact_icon: `mr-5`,
    copyright: `text-center my-[20px] text-[14px] font-[300] leading-[normal]`,
    divider: `horizontal_divider bg-dividerColor opacity-40 mt-[50px]`,
    icons: `mt-3 flex space-x-7
            screen-970:mt-5
    `,
    hoverText: `hover:text-secondaryRed`,
    link_text: `text-[16px] font-[300] leading-[normal] `,
  };

  export { footerStyles } 